import { SvgIcon } from '@mui/material';
import { forwardRef } from 'react';
import BusinessHistorySvg from './BusinessHistory.svg';

export const BusinessHistory = forwardRef(function BusinessHistory(props, ref) {
  return (
    <SvgIcon
      {...props}
      ref={ref}
      component={BusinessHistorySvg}
      viewBox="0 0 40 41"
    />
  );
});
